import React, { memo, useCallback, useEffect, useMemo, useState } from 'react';
import LinkComponent from '../../../typography/Link';
const validLinkAttributes = ['id', 'title'];
const Link = _ref => {
  let {
    callback,
    href,
    target,
    title,
    ...otherProps
  } = _ref;
  const [finalTitle, setFinalTitle] = useState(undefined);
  const [attributes, setAttributes] = useState({});
  const handleClick = useCallback(event => {
    if (callback) {
      event.preventDefault();
      const link = () => {
        const finalTarget = target || (attributes === null || attributes === void 0 ? void 0 : attributes.target);
        if (!finalTarget || finalTarget === '_self') {
          window.location.href = href;
        } else {
          window.open(href, finalTarget);
        }
      };
      callback({
        event,
        attributes,
        link
      });
    }
  }, [attributes, callback, href, target]);
  const parseTitleString = useCallback(str => {
    try {
      const parsedJson = JSON.parse(str);
      const finalAttributes = Object.entries(parsedJson).reduce((acc, _ref2) => {
        let [key, value] = _ref2;
        if (validLinkAttributes.includes(key)) {
          acc[key] = value;
        }
        return acc;
      }, {});
      setAttributes(finalAttributes);
    } catch (error) {
      setFinalTitle(str);
    }
  }, []);
  useEffect(() => {
    title && parseTitleString(title);
  }, [parseTitleString, title]);
  const linkProps = useMemo(() => {
    const {
      id,
      ...otherAttrs
    } = attributes;
    return {
      href,
      target,
      title: finalTitle,
      onClick: handleClick,
      ...otherAttrs,
      ...otherProps
    };
  }, [attributes, finalTitle, handleClick, href, otherProps, target]);
  return /*#__PURE__*/React.createElement(LinkComponent, linkProps);
};
export default /*#__PURE__*/memo(Link);